import useAsync from 'react-use/esm/useAsync';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { RemoteDocResponse } from './types';

/** Pide al backend remote-docs el documento `url` ya procesado en bloques. */
export function useRemoteDoc(url?: string) {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  return useAsync(async (): Promise<RemoteDocResponse | undefined> => {
    if (!url) return undefined;
    const base = await discoveryApi.getBaseUrl('remote-docs');
    const response = await fetchApi.fetch(`${base}/content?url=${encodeURIComponent(url)}`);
    if (!response.ok) throw await ResponseError.fromResponse(response);
    return (await response.json()) as RemoteDocResponse;
  }, [url, discoveryApi, fetchApi]);
}
